import { createApp } from '@backstage/frontend-defaults';
import { convertLegacyAppOptions, convertLegacyPlugin } from '@backstage/core-compat-api';
import { convertLegacyEntityCardExtension, convertLegacyEntityContentExtension } from '@backstage/plugin-catalog-react/alpha';
import { SignInPage } from '@backstage/core-components';
import { OAuth2 } from '@backstage/core-app-api';
import {
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { harborPlugin, HarborWidget, HarborPage } from '@digitalist-open-cloud/backstage-plugin-harbor';
import { argocdPlugin, EntityArgoCDContent, EntityArgoCDOverviewCard, EntityArgoCDHistoryCard } from '@roadiehq/backstage-plugin-argo-cd';
import { navModule } from './modules/nav';

const convertedHarborPlugin = convertLegacyPlugin(harborPlugin, {
  extensions: [
    convertLegacyEntityCardExtension(HarborWidget),
    convertLegacyEntityContentExtension(HarborPage),
  ],
});

const convertedArgoCDPlugin = convertLegacyPlugin(argocdPlugin, {
  extensions: [
    convertLegacyEntityContentExtension(EntityArgoCDContent),
    convertLegacyEntityCardExtension(EntityArgoCDOverviewCard),
    convertLegacyEntityCardExtension(EntityArgoCDHistoryCard),
  ],
});

const oidcAuthApiRef = createApiRef<any>({ id: 'auth.oidc' });

const legacyOptions = convertLegacyAppOptions({
  apis: [
    createApiFactory({
      api: oidcAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: { id: 'oidc', title: 'Keycloak', icon: () => null },
          environment: configApi.getOptionalString('auth.environment'),
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
  ],
  components: {
    SignInPage: props => (
      <SignInPage
        {...props}
        provider={{
          id: 'oidc',
          title: 'Keycloak',
          message: 'Sign in with Keycloak',
          apiRef: oidcAuthApiRef,
        }}
      />
    ),
  },
});

export default createApp({
  features: [catalogPlugin, navModule, legacyOptions, convertedHarborPlugin, convertedArgoCDPlugin],
});
